import {useState} from "react";
import {useTranslation} from "react-i18next";
import {useDispatch, useSelector} from "react-redux";

import useColumns from "../../../../../Requests/OrderProcessing/utils/hooks/useColumns";
import {LOGIST_REQ_TABLE} from "../../../../../Requests/RequestRegister/RequestTable/utils/constants";
import {getRequest} from "../../../../../Requests/RequestsSlice";
import {selectIncomingRequests} from "../../../../redux/selectors";
import {makeStockPoolRqstsTableData} from "../../constants";

const useIncomingReqTable = ({selectedSP}) => {
  const {
    i18n: {language},
  } = useTranslation();

  const allRequests = useSelector(selectIncomingRequests);

  const dispatch = useDispatch();

  const [isModalOpen, setIsModalOpen] = useState(false);

  const columns = useColumns(LOGIST_REQ_TABLE);
  const defaultData = makeStockPoolRqstsTableData(allRequests, language);

  const onIncomingReqTableRowDoubleClick = request => {
    const id = request?.requestId ?? request?.id;
    if (id) dispatch(getRequest(id));
    setIsModalOpen(true);
  };

  return {columns, defaultData, onIncomingReqTableRowDoubleClick, isModalOpen, setIsModalOpen};
};

export default useIncomingReqTable;
